import {createActions, createReducer} from "reduxsauce";
import Immutable from "seamless-immutable";

const {Types, Creators} = createActions({
    segmentation: {},
    segmentationSuccess: null,
    segmentationFailure: null,

    segmentationSchools: {},
    segmentationSchoolsSuccess: null,
    segmentationSchoolsFailure: null,
});

export const SegmentationTypes = Types;
export default Creators;

const INITIAL_STATE = Immutable({
    segmentation: {},
    segmentationError: "",

    segmentationSchools: [],
    segmentationSchoolsProcessStart: false,
    segmentationSchoolsError: "",
});

/* Selectors */
export const SegmentationSelectors = {};

export const segmentationReducer = (state) => {
    return {
        ...state
    };
};
export const segmentationSuccessReducer = (state, action) => {
    const {segmentation} = action;
    return {
        ...state,
        segmentation: segmentation
    };
};
export const segmentationFailureReducer = (state, action) => {
    const {error} = action;

    return {
        ...state,
        segmentationError: error
    };
};

export const segmentationSchoolsReducer = (state) => {
    return {
        ...state,
        segmentationSchoolsProcessStart: true
    };
};
export const segmentationSchoolsSuccessReducer = (state, action) => {
    const {segmentationSchools} = action;
    return {
        ...state,
        segmentationSchools: segmentationSchools,
        segmentationSchoolsProcessStart: false,
    };
};
export const segmentationSchoolsFailureReducer = (state, action) => {
    const {error} = action;

    return {
        ...state,
        segmentationSchools: [],
        segmentationSchoolsError: error,
        segmentationSchoolsProcessStart: false,
    };
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SEGMENTATION]: segmentationReducer,
    [Types.SEGMENTATION_SUCCESS]: segmentationSuccessReducer,
    [Types.SEGMENTATION_FAILURE]: segmentationFailureReducer,

    [Types.SEGMENTATION_SCHOOLS]: segmentationSchoolsReducer,
    [Types.SEGMENTATION_SCHOOLS_SUCCESS]: segmentationSchoolsSuccessReducer,
    [Types.SEGMENTATION_SCHOOLS_FAILURE]: segmentationSchoolsFailureReducer,
});
